<template>
	<div class="hotel-list-favorite-details">
		<div class="hotel-list-favorite-details__info-wrapper">
			<span class="hotel-list-favorite-details__info-content">
				{{ details }}
			</span>
		</div>
		<span class="hotel-list-favorite-details__link">
			<LinkButton
				as="div"
				:label="translate('favouriteHotelList.favoriteDetailsLink')"
			/>
		</span>
	</div>
</template>

<script setup lang="ts">
import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import { useTranslations } from '@helper/composables/translations';

defineProps<{ details: string }>();

const { translate } = useTranslations();
</script>

<style lang="scss" scoped>
.hotel-list-favorite-details {
	padding-inline: 0;
	display: flex;
	flex-direction: row;
	align-items: end;
	margin-top: 0;
	gap: $spacer-4;

	&__info-content {
		font-size: $font-small-2;
		font-weight: $font-weight-semibold;
	}

	@container hotel_item_list (max-width: 72.4rem) {
		&__info-content {
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			line-clamp: 2;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}

	@container hotel_item_list (min-width: 72.5rem) {
		margin-top: $spacer-6;
		flex-direction: column;
		justify-content: flex-start;

		&__link {
			flex-grow: 1;
			display: flex;
			align-items: end;
		}

		&__info-content {
			text-align: right;
		}
	}

	@container hotel_item_list (min-width: 90rem) {
		&__info-content {
			display: block;
			max-width: 22rem;
			margin-top: $spacer-6;
			margin-left: $spacer-6;
		}
	}
}
</style>
